import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    box-shadow: ${props => props.backgroundShadow || 'none'};
`;

const Card7 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props?.backgroundColor?.trim() || (props.content && props?.content.backgroundColor?.trim());
    const backgroundShadow = props?.backgroundShadow?.trim() || (props.content && props?.content.backgroundShadow?.trim());
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);

    const hasMoreThanThreeItems = items && items.length > 3;

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            backgroundShadow={backgroundShadow}
            className={`card7 relative ${hasMoreThanThreeItems ? 'flex flex-col lg:flex-row' : 'flex flex-row'} justify-between items-center gap-2 lg:gap-0 ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            {items?.map((item) => (
                <MapTo 
                    key={item.id} 
                    items={item} 
                    className={item.__typename === "ContentfulRichText" ? 
                        hasMoreThanThreeItems 
                            ? `[&>h2]:text-h3 [&>h2]:font-bold lg:[&>h2]:font-[700] lg:[&>h2]:text-h1_48 [&>p]:text-text_paragraph [&>p]:mt-2 text-center` 
                            : `[&>h2]:text-h3 [&>h2]:font-bold lg:[&>h2]:text-h1_72 [&>p]:text-text_paragraph`
                        : ''}
                />
            ))}
        </StyledContainer>
    );
};

export default Card7; 